import { fetchUnreadNewsItemsSuccessAction } from 'common/reducers/news';
import apiRequestService from 'common/services/api/apiRequestService';
import { Method } from 'common/services/http/types';

export const NEWS_READING_POSTPONED = 'newsAndAlerts/NEWS_READING_POSTPONED';

const UNREAD_INTERVAL_TIMEOUT = 30 * 1000;

let unreadInterval: NodeJS.Timeout | null | number = null;

export const fetchUnreadNews = () => (dispatch) =>
  apiRequestService({
    method: '/newsItems/unread',
    httpMethod: Method.Get,
  }).then(({ unread }) => dispatch(fetchUnreadNewsItemsSuccessAction(unread)));

export const startUnreadNewsCheckingInterval =
  (checkImmediately = true) =>
  (dispatch) => {
    const fn = () => {
      dispatch(fetchUnreadNews());
    };

    if (checkImmediately) {
      fn();
    }

    if (unreadInterval) {
      clearInterval(unreadInterval);
    }

    unreadInterval = setInterval(fn, UNREAD_INTERVAL_TIMEOUT);
  };

export const stopUnreadNewsCheckingInterval = () => () => {
  clearInterval(unreadInterval as number);
  unreadInterval = null;
};
